import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';

export const UserCountErrorDialog = (props: any) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      heading={t('Too Few Platform Users')}
      buttonText={t('Close')}
      leftBtn={null}
      actionBtnColor={'blue'}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'There are currently more active platform users than licenses selected. Please increase the number of platform users in your plan selection.'
          )}
        </Typography>
      </div>
    </Modal>
  );
};
